import { DeleteOutline, Link, LinkOff } from "@mui/icons-material";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";
import { DocumentActions } from "..";
import { PublishedIcon } from "../../images/svg/publishedIcon";
import { WIPIcon } from "../../images/svg/WIPIcon";
import { Association, LinksUnlinksOnUpdate } from "../../interfaces";
import { UploadPercentage } from "../../redux/slices/utils";
import { convertSize, TAG_CANONICAL_NAMES } from "../../utils";
import FileSize from "../fileSize";

export const giveMeLocationAndDocumentTags = (tags_info: any) => {
    let location_tags: any = null;
    let document_tags: any = null;
    let document_status: any = null;
    let document_priority: any = null;

    tags_info?.forEach((_: any) => {
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_type) {
            document_tags = { value: _.tag_id, label: _.tag_name, ..._ }
        }
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_status) {
            document_status = { value: _.tag_id, label: _.tag_name, ..._ }
        }
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.folders) {
            location_tags = { value: _.tag_id, label: _.tag_name, ..._ }
        }

        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_priority) {
            document_priority = { value: _.tag_id, label: _.tag_name, ..._ }
        }
    })
    return { location_tags, document_tags, document_priority, document_status };
}

export const DocumentTableColumn = (arg: {
    view?: (row: any) => void,
    onDelete?: (row: any) => void,
    openAssociation?: (row: any) => void,
    updatePublishStatus?: (row: any) => void,
    hideDelete?: boolean,
    handleAnnotate?: (id: string) => void,
    unlinkDocument?: (row: any) => void,
    publishable?: boolean,
    isLinkable?: boolean,
    disablePreview?: boolean,
    handleDuplicate?: (row: any) => void,
    handleDataSheet?: (row: any) => void,
    showDuplicate?: boolean,
    forceRelease?: (row: any) => void,
    handleShare?: (row: any) => void,
    uploads?: UploadPercentage[],
    onDocumentUploadComplete?: () => void,
    isCommonModule: boolean
}) => {

    const {
        view = () => false,
        onDelete = () => false,
        openAssociation = () => false,
        updatePublishStatus = () => false,
        hideDelete = false,
        handleAnnotate = () => false,
        unlinkDocument = () => false,
        publishable = false,
        isLinkable = false,
        disablePreview = false,
        handleDuplicate = () => false,
        showDuplicate = false,
        forceRelease = () => false,
        handleShare = () => false,
        handleDataSheet = () => false,
        uploads = [],
        onDocumentUploadComplete = () => false,
        isCommonModule
    } = arg;

    let columns: GridColDef[] = [
        {
            field: 'sequence_id', headerName: 'Doc ID', width: 128, renderCell: (params: GridRenderCellParams) => {
                return <Box sx={{ position: "relative", lineHeight: 1.43, width: 'max-content' }}>
                    <Typography id="view-documents" sx={{ color: 'blue', textDecoration: "underline", cursor: "pointer" }} variant="body2" onClick={() => view(params.row)}>{`${params.row?.sequence_id}-r${params.row?.version}`}</Typography>
                    <Tooltip title={params?.row?.released ? "Published" : publishable ? "Work in progress, click to publish the item" : "Not Published"} >
                        <Stack
                            id={params.row.released ? `doc-publish-success` : `doc-unpublish`}
                            sx={{
                                position: "absolute",
                                top: -4,
                                right: -30,
                                height: 24,
                                cursor: params.row.released ? "default" : "pointer"
                            }}>
                            {params?.row?.released
                                ? <PublishedIcon sx={{ width: 30, height: 30 }} />
                                : <WIPIcon onClick={(e) => {
                                    e.stopPropagation();
                                    if (publishable) {
                                        updatePublishStatus(params.row)
                                    }
                                }} sx={{ width: 30, height: 30 }} />}
                        </Stack>
                    </Tooltip>
                </Box>
            }
        },
        {
            field: 'actions',
            // type: 'actions',
            headerName: 'Actions',
            width: 190,
            cellClassName: 'actions',
            sortable: false,
            hideSortIcons: true,
            disableColumnMenu: true,
            resizable: false,
            renderCell: (params: any) => <DocumentActions
                row={params.row}
                uploads={uploads}
                forceRelease={forceRelease}
                handleDuplicate={showDuplicate ? handleDuplicate : undefined}
                handleShare={handleShare}
                disablePreview={disablePreview}
                handleDataSheet={isCommonModule ? undefined : handleDataSheet}
                onDocumentUploadComplete={onDocumentUploadComplete}
            />
        },
        {
            field: 'file_name', headerName: 'File Name', width: 200, renderCell: (params: GridRenderCellParams) => {
                return <Tooltip title={params.row.file_name}><Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row.file_name}</Typography></Tooltip>
            }
        },
        // {
        //     field: 'document_type_tags', headerName: 'Document Type', width: 250,
        //     valueGetter: (value, row, column, apiRef): GridValueGetter => giveMeLocationAndDocumentTags(row.tags_info).document_tags?.label,
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'document_type_tags') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }

        //         const document = giveMeLocationAndDocumentTags(params.row.tags_info).document_tags;

        //         if (document) {
        //             return (
        //                 <Stack
        //                     spacing={1}
        //                     direction={"row"}
        //                     id={"tagsChip"}
        //                     sx={{
        //                         width: "100%",
        //                     }}>
        //                     <Chip sx={{ borderColor: document?.tag_group_color || '#3b82f6', backgroundColor: document?.tag_group_color || '#e5f6fd', color: `${hexToGrayscale(document?.tag_group_color || '#e5f6fd') > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} variant="outlined" size={"small"} label={`${document?.label}`} />
        //                 </Stack>
        //             );
        //         } else {
        //             return <></>
        //         }
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return giveMeLocationAndDocumentTags(row.tags_info).document_tags?.label ?? "Grouping";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        // {
        //     field: 'document_priority', headerName: 'Document Priority', width: 250,
        //     valueGetter: (value, row, column, apiRef): GridValueGetter => giveMeLocationAndDocumentTags(row.tags_info).document_priority?.label,
        //     renderCell: (params: GridRenderCellParams) => {
        //         if (params.rowNode.type === 'group') {
        //             if (params.rowNode.groupingField === 'document_priority') {
        //                 return params.rowNode.groupingKey;
        //             }
        //             return '';
        //         }

        //         const document = giveMeLocationAndDocumentTags(params.row.tags_info).document_priority;

        //         if (document) {
        //             return (
        //                 <Stack
        //                     spacing={1}
        //                     direction={"row"}
        //                     id={"tagsChip"}
        //                     sx={{
        //                         width: "100%",
        //                     }}>
        //                     <Chip sx={{ borderColor: document?.tag_group_color || '#3b82f6', backgroundColor: document?.tag_group_color || '#e5f6fd', color: `${hexToGrayscale(document?.tag_group_color || '#e5f6fd') > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} variant="outlined" size={"small"} label={`${document?.label}`} />
        //                 </Stack>
        //             );
        //         } else {
        //             return <></>
        //         }
        //     },
        //     groupingValueGetter: (value, row, column, apiRef) => {
        //         return giveMeLocationAndDocumentTags(row.tags_info).document_priority?.label ?? "Grouping";
        //     },
        //     disableColumnMenu: true,
        //     sortable: false,
        // },
        {
            field: 'serial_num',
            headerName: 'Sequence Number',
            width: 150,
            renderCell: (params: GridRenderCellParams) => {
                return <Typography variant="body2" >{params?.row?.serial_num ?? ""}</Typography>
            }
        },
        {
            field: 'size', headerName: 'Size', width: 100, renderCell: (params: GridRenderCellParams) => {
                return <FileSize id={params.row._id} status={params.row.status} size={params.row?.size ?? 0} />
            },
            groupingValueGetter: (value, row, column, apiRef) => {
                return convertSize(row?.size ?? 0)
            },
            valueGetter: (value, row, column, apiRef) => {
                return convertSize(row?.size ?? 0)
            },
        },
        // {
        //     field: 'annotate', headerName: 'Annotate', width: 100, renderCell: (params: GridRenderCellParams) => {
        //         if (params.row?.file_name?.includes("pdf")) {
        //             return <Button color="primary" onClick={() => handleAnnotate && handleAnnotate(params?.row?._id)}>Annotate</Button>
        //         }
        //         return null;
        //     }
        // },
        {
            field: 'link', headerName: 'Dependencies', width: 140, renderCell: (params: GridRenderCellParams) => {
                return <IconButton onClick={(e) => {
                    e.stopPropagation();
                    openAssociation(params.row);
                }}><Link color={"info"} /></IconButton>
            },
            disableColumnMenu: true,
            sortable: false,
        },
        { field: 'created_user', headerName: 'Uploaded By', width: 150 },
        {
            field: 'created_time', headerName: 'Uploaded Date', width: 250, renderCell: (params: GridRenderCellParams) => {
                return <Typography variant="body2">{moment(params.row.created_time).format('lll')}</Typography>
            }
        },
        { field: 'modified_user', headerName: 'Last modified by', width: 150 },
        {
            field: 'modified_time', headerName: 'Last modified date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.modified_time ? moment(params.row.modified_time).format('lll') : ""}</Typography>
            }
        },
        { field: 'released_user', headerName: 'Published by', width: 150 },
        {
            field: 'released_time', headerName: 'Published date', width: 250, renderCell: (params: GridRenderCellParams) => {
                if (params.rowNode.type === 'group') {
                    return params.value;
                }
                return <Typography variant="body2">{params.row.released_time ? moment(params.row.released_time).format('lll') : ""}</Typography>
            }
        },
        {
            field: 'delete', headerName: 'Delete', width: 100, renderCell: (params: GridRenderCellParams) => {
                return <Stack direction={"row"}>
                    {unlinkDocument && isLinkable && <Tooltip title={`Unlink the Document "${params?.row?.sequence_id}"`}>
                        <IconButton onClick={(e) => {
                            e.stopPropagation();
                            unlinkDocument(params.row);
                        }}>
                            <LinkOff color={"action"} />
                        </IconButton>
                    </Tooltip>}
                    {!hideDelete && <Tooltip title={params?.row?.released ? `${params?.row?.sequence_id} Revision is published` : `Delete the Document ${params?.row?.sequence_id}`}>
                        <IconButton disableRipple={params?.row?.released} onClick={(e) => {
                            e.stopPropagation();
                            if (!params?.row?.released) {
                                onDelete(params.row)
                            }
                        }}>
                            <DeleteOutline color={params?.row?.released ? "disabled" : "error"} />
                        </IconButton>
                    </Tooltip>}
                </Stack>
            },
            disableColumnMenu: true,
            sortable: false,
        }
    ];

    if (!handleAnnotate) {
        columns = columns.filter(c => c.field !== "annotate")
    }


    return columns;
};

export const fileSelectOptions = [
    { value: "single", label: "Upload Single File" },
    { value: "multiple", label: "Upload Multiple Files" },
    { value: "iedraw", label: "New IEDRAW File", isBeta: true },
    { value: "iedocs", label: "New IEDOCS File", isBeta: true },
];

export const documentTypes = [
    { value: ".docx", label: "Word" },
    { value: ".xlsx", label: "Excel" },
    { value: ".ppt", label: "PPT" },
    { value: ".pdf", label: "PDF" },
]

export const getEmptyXlsxFile = async () => {
    const blob = new Blob([''], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    return blob;
}

export const getEmptyPptFile = async () => {
    const blob = new Blob([''], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    return blob;
}

export const getEmptyPdfFile = async () => {
    // Each line ends with \n to maintain exact byte positions
    const pdfContent = `%PDF-1.7\n\
%âãÏÓ\n\
1 0 obj\n\
<<\n\
/Type /Catalog\n\
/Pages 2 0 R\n\
/PageLayout /OneColumn\n\
/ViewerPreferences <</DisplayDocTitle true>>\n\
/Lang (en-US)\n\
>>\n\
endobj\n\
2 0 obj\n\
<<\n\
/Type /Pages\n\
/Kids [3 0 R]\n\
/Count 1\n\
>>\n\
endobj\n\
3 0 obj\n\
<<\n\
/Type /Page\n\
/Parent 2 0 R\n\
/MediaBox [0 0 612 792]\n\
/CropBox [0 0 612 792]\n\
/Resources <<\n\
/Font <<\n\
/F1 4 0 R\n\
>>\n\
>>\n\
/Contents 5 0 R\n\
>>\n\
endobj\n\
4 0 obj\n\
<<\n\
/Type /Font\n\
/Subtype /Type1\n\
/BaseFont /Helvetica\n\
>>\n\
endobj\n\
5 0 obj\n\
<<\n\
/Length 0\n\
>>\n\
stream\n\
\n\
endstream\n\
endobj\n\
xref\n\
0 6\n\
0000000000 65535 f\n\
0000000015 00000 n\n\
0000000159 00000 n\n\
0000000225 00000 n\n\
0000000434 00000 n\n\
0000000522 00000 n\n\
trailer\n\
<<\n\
/Size 6\n\
/Root 1 0 R\n\
/ID [<1234567890ABCDEF> <1234567890ABCDEF>]\n\
>>\n\
startxref\n\
574\n\
%%EOF`;

    const blob = new Blob([pdfContent], { type: 'application/pdf' });
    return blob;
}
export const getEmptyDocxFile = async () => {
    const blob = new Blob([''], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    return blob;
}

export const giveMeLinksAndUnlinksForDocuments = (data: any): LinksUnlinksOnUpdate => {
    let obj: LinksUnlinksOnUpdate = {
        links: [],
        unlinks: [],
    }
    let lsChip: { [key: string]: string[] } = JSON.parse(localStorage.getItem('selectedChip') ?? "{}");
    data?.associations?.forEach((asso: Association) => {
        let linkedIds: string[] = [];
        let unlinkedIds: string[] = [];
        asso.object_details?.forEach(od => {
            if (lsChip[asso.object_type]?.includes(od._id)) {
                linkedIds.push(od._id);
            } else {
                unlinkedIds.push(od._id);
            }
        });
        obj.links.push({ object_ids: linkedIds.filter(Boolean), object_type: asso.object_type })
        obj.unlinks.push({ object_ids: unlinkedIds.filter(Boolean), object_type: asso.object_type })
    })

    return obj;
}